var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stage!=='production')?_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"stage-badge-container"},[_c('h1',{staticClass:"stage-badge"},[_vm._v(_vm._s(_vm.stage))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }